module.exports = __webpack_public_path__ + "img/icon-close.5e30b39e.svg";